<template>
  <div class="p-contact-create-form">
    <div class="p-contact-create-form__content">
      <contact-form
        ref="form"
        v-model="formValue"
        :contact-list="notAddedContactList"
        is-extended
        @status="handleFormStatusChange"
      >
        <contact-form-alert v-if="isAlertShown" />
      </contact-form>
    </div>
    <div class="p-divider" />
    <div class="p-contact-create-form__footer">
      <el-button
        type="secondary"
        data-test-id="contact-create-form.button-cancel"
        @click="handleCancelClick"
      >
        {{ $t('action.cancel') }}
      </el-button>
      <el-button
        native-type="submit"
        :loading="isContactCreating || isContactEditing"
        :disabled="isSaveDisabled"
        data-test-id="contact-create-form.button-save"
        @click="handleSaveClick"
      >
        {{ $t('action.add') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { areContactRequiredFieldsFilled } from '@/app/domain/Contact';
import { setAutoFocus } from '@/app/library/setAutoFocus';
import ContactForm from '@/app/components/ContactForm';
import ContactFormAlert from '@/app/components/ContactFormAlert';

export default {
  name: 'ContactCreateForm',
  components: {
    ContactForm,
    ContactFormAlert
  },
  inject: {
    isAlertShown: {
      from: 'isAlertShown',
      default: false
    }
  },
  emits: [
    'submit',
    'cancel'
  ],
  data() {
    return {
      formValue: {
        id: undefined,
        type: [],
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        phone: '',
        jobTitle: undefined,
        userId: undefined
      },
      formStatus: {}
    };
  },
  computed: {
    ...mapGetters('app', [
      'notAddedContactList',
      'isContactCreating',
      'isContactEditing'
    ]),
    isSaveDisabled() {
      return !areContactRequiredFieldsFilled(this.formValue, true);
    }
  },
  async mounted() {
    await this.$nextTick();
    setAutoFocus(this.$el);
  },
  methods: {
    ...mapActions('app', [
      'createContact',
      'editContact'
    ]),
    handleFormStatusChange(status) {
      this.$set(this.formStatus, status.name, status.value);
    },
    async handleSaveClick() {
      const isFormValid = await this.$refs.form.validate();

      if (isFormValid) {
        if (this.formValue.id) {
          await this.editContact(this.formValue);
        } else {
          await this.createContact(this.formValue);
        }
        this.$emit('submit');
      }
    },
    handleCancelClick() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@uikit/ui-kit/themes/acronis/src/common/variables';

.p-contact-create-form {
  padding: 16px 24px;

  .p-divider {
    height: $av-border-width-sm;
    background-color: var(--av-brand-lighter);
    margin-left: -24px;
    margin-right: -24px;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}
</style>
